import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { RadioButton, Text } from '../../../components';
import { Style } from '../../../constants';

type Props = {
  options: Array<{ value: string; label: string }>;
  selected: string;
  onSelect: (value: string) => void;
  onClose: () => void;
};

export default function MobileSortSheet({
  options,
  selected,
  onSelect,
  onClose,
}: Props) {
  React.useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <html.div style={styles.backdrop} onClick={onClose}>
      <html.div style={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <html.div style={[Style.row, Style.justifyCenter, styles.handleWrap]}>
          <html.div style={styles.handle} />
        </html.div>
        <html.div style={styles.content}>
          <Text as="p" style={styles.title}>
            Sort by...
          </Text>
          <html.div>
            {options.map((option) => {
              const isSelected = option.value === selected;
              return (
                <html.button
                  key={option.value}
                  style={[Style.row, Style.alignCenter, styles.item]}
                  onClick={() => {
                    onSelect(option.value);
                    onClose();
                  }}
                >
                  <RadioButton selected={isSelected} />
                  <Text style={styles.itemLabel}>{option.label}</Text>
                </html.button>
              );
            })}
          </html.div>
        </html.div>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  sheet: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    overflow: 'hidden',
  },
  handleWrap: {
    paddingTop: 8,
  },
  handle: {
    width: 44,
    height: 4,
    borderRadius: 4,
    backgroundColor: '#dedede',
  },
  content: {
    paddingTop: 8,
    paddingBottom: 24,
    paddingInline: 16,
  },
  title: {
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 1.4,
    color: color.neutral100,
    textAlign: 'center',
    marginBlockStart: 0,
    marginBlockEnd: 8,
  },
  item: {
    width: '100%',
    gap: 8,
    paddingInline: 16,
    paddingBlock: 12,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: color.neutral20,
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  itemLabel: {
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 1.4,
    color: color.neutral100,
  },
});
